__turbopack_context__.v({
  "button": "RTikIW_button",
  "searchItem": "RTikIW_searchItem",
});
